import { filterL, go, map } from "fxjs/es";
import { PROCESSING_TASK } from "./const.js";
export const _handleMouseDownOnSelectorPathEl = (self, event) => {
  const translate_transforming = self._getTranslateTransformingThrowable();
  const { clientX: client_x, clientY: client_y } = event;
  const point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  const els = go(
    self._els.entries(),
    filterL(([id]) => self._selected_el_ids.has(id)),
    map(([, { wrapper_el }]) => wrapper_el)
  );
  if (els.length <= 0) {
    return;
  }
  translate_transforming.start({
    x: point.x,
    y: point.y,
    els,
  });
  self._processing_task = PROCESSING_TASK.TRANSLATE_TRANSFORMING;
};
